const state = {
  myBids: []
}

const mutations = {
  SET_MY_BIDS(state, bids) {
    state.myBids = bids
  },
  
  ADD_BID(state, bid) {
    const index = state.myBids.findIndex(item => item.bid_no === bid.bid_no)
    if (index > -1) {
      state.myBids.splice(index, 1, bid)
    } else {
      state.myBids.unshift(bid)
    }
  },
  
  REMOVE_BID(state, bidNo) {
    state.myBids = state.myBids.filter(item => item.bid_no !== bidNo)
  },
  
  CLEAR_BIDS(state) {
    state.myBids = []
  }
}

const actions = {
  setMyBids({ commit }, bids) {
    commit('SET_MY_BIDS', bids)
  },
  
  addBid({ commit }, bid) {
    commit('ADD_BID', bid)
  },
  
  removeBid({ commit }, bidNo) {
    commit('REMOVE_BID', bidNo)
  },
  
  clearBids({ commit }) {
    commit('CLEAR_BIDS')
  }
}

const getters = {
  myBids: state => state.myBids,
  
  getBidByNo: state => bidNo => {
    return state.myBids.find(item => item.bid_no === bidNo)
  },
  
  bidCount: state => {
    return {
      all: state.myBids.length,
      won: state.myBids.filter(item => item.status === 'won').length,
      lost: state.myBids.filter(item => item.status === 'lost').length,
      pending: state.myBids.filter(item => item.status === 'pending').length
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
